import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Company from "./Company";
import CreatableSelect from "react-select/creatable";
const config = require("../config.json");

export default class CompanyAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    newCompany: {
      companyName: "",
      id: uuid(),
      points: { totalPoints: 0, weekPoints: {} },
      avgTotalPoints: 0,
      totalPoints: 0,
      campaignId: "",
      companyKey: "",
      avatarId: "",
      maxAmountOfUserTeams: "",
      subDivisions: [],
    },
    companies: [],
    campaigns: [],
    organizationImages: [],
  };

  fetchOrganizationImages = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/images?bucketName=${config.s3.organizationImagesBucket}`
      );
      if (res.data?.Contents) {
        const organizationImages = res.data.Contents;
        this.setState({ organizationImages });
      }
    } catch (err) {
      console.log(err);
    }
  };

  addCompanyToCampaign = async (campaignId, companyId) => {
    const params = {
      campaignId,
      companyId,
    };
    await axios.post(
      `${config.api.invokeUrl}/campaign/${campaignId}/addcompany`,
      params
    );
  };

  handleAddCompany = async (company, event) => {
    event.preventDefault();
    try {
      company.campaignId = document.getElementById("campaigns").value;
      const params = {
        id: company.id,
        companyName: company.companyName,
        points: { totalPoints: 0, weekPoints: {} },
        avgTotalPoints: 0,
        totalPoints: 0,
        campaignId: company.campaignId,
        companyKey: company.companyKey.toUpperCase(),
        campaignUsers: [],
        avatarId: company.avatarId,
        maxAmountOfUserTeams: parseInt(company.maxAmountOfUserTeams),
        subDivisions: company.subDivisions || [],
      };
      await axios.post(
        `${config.api.invokeUrl}/companies/${company.id}`,
        params
      );

      this.addCompanyToCampaign(company.campaignId, company.id);

      this.setState({
        companies: [...this.state.companies, this.state.newCompany],
      });
      this.setState({
        newCompany: {
          companyName: "",
          id: uuid(),
          points: { totalPoints: 0, weekPoints: {} },
          avgTotalPoints: 0,
          userAmount: 0,
          companyKey: "",
          avatarId: "",
          maxAmountOfUserTeams: 0,
          subDivisions: [],
        },
      });
    } catch (err) {
      window.alert("FEJL: Nøglen er muligvis brugt allerede");
      console.log(err);
    }
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign/active`);
      const campaigns = res.data;
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateCompany = async (company) => {
    let isChangingCampaign;

    if (
      this.state.campaigns.find((campaign) => campaign.id == company.campaignId)
    ) {
      isChangingCampaign = !this.state.campaigns
        .find((campaign) => campaign.id == company.campaignId)
        .campaignCompanies.includes(company.id);
    } else {
      isChangingCampaign = true;
    }

    try {
      const params = {
        id: company.id,
        companyName: company.companyName,
        campaignId: company.campaignId,
        points: isChangingCampaign
          ? { totalPoints: 0, weekPoints: {} }
          : company.points,
        kgCO2: isChangingCampaign ? 0 : company.kgCO2 ? company.kgCO2 : 0,
        avgTotalPoints: isChangingCampaign ? 0 : company.avgTotalPoints,
        companyKey: company.companyKey,
        totalPoints: company.totalPoints ? company.totalPoints : 0,
        campaignUsers: isChangingCampaign
          ? []
          : company.campaignUsers
          ? company.campaignUsers
          : [],
        avatarId: company.avatarId ? company.avatarId : "",
        maxAmountOfUserTeams: company.maxAmountOfUserTeams
          ? parseInt(company.maxAmountOfUserTeams)
          : 0,
        subDivisions: company.subDivisions || [],
      };

      await axios.patch(
        `${config.api.invokeUrl}/companies/${company.id}`,
        params
      );
      if (isChangingCampaign) {
        await this.addCompanyToCampaign(company.campaignId, company.id);
      }
    } catch (err) {
      console.log(err);
    }
    const updatedCompanies = [...this.state.companies].filter(
      (c) => c.id !== company.id
    );
    updatedCompanies.push(company);
    this.setState({ companies: updatedCompanies });
  };

  handleDeleteCompany = async (id, event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/companies/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedCompanies = [...this.state.companies].filter(
        (company) => company.id !== id
      );
      this.setState({ companies: updatedCompanies });
    }
  };

  fetchCompanies = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/companies`);
      const companies = res.data;
      this.setState({ companies: companies });
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newCompany: {
        ...this.state.newCompany,
        [name]: value,
      },
    });
  }

  handleSubDivisionsChange = (selectedOptions) => {
    const subDivisions = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    this.setState({
      newCompany: {
        ...this.state.newCompany,
        subDivisions: subDivisions,
      },
    });
  };

  componentDidMount = () => {
    this.fetchOrganizationImages();
    this.fetchCampaigns().then(() => {
      this.fetchCompanies();
    });
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Virksomhed Admin</h1>
            <p className="subtitle is-5">Tilføj og fjern virksomheder</p>
            <br />
            <div className="columns is-multiline">
              <div className="column is-full">
                <form
                  onSubmit={(event) =>
                    this.handleAddCompany(this.state.newCompany, event)
                  }
                >
                  <div className="field">
                    <div className="control">
                      <input
                        className="input is-medium"
                        name={"companyName"}
                        type="text"
                        placeholder="Indtast navn"
                        value={this.state.newCompany.companyName}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="control">
                      <input
                        className="input is-medium"
                        name={"maxAmountOfUserTeams"}
                        type="text"
                        placeholder="Indtast max antal bruger oprettede hold"
                        value={this.state.newCompany.maxAmountOfUserTeams}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="control">
                      <input
                        className="input is-medium"
                        name={"companyKey"}
                        type="text"
                        placeholder="Indtast company key"
                        value={this.state.newCompany.companyKey}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="control">
                      <select
                        className="select is-medium"
                        name="campaigns"
                        id="campaigns"
                      >
                        {this.state.campaigns.map((campaign) => {
                          return (
                            <option key={campaign.id} value={campaign.id}>
                              {campaign.campaignName}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="control">
                      Logo:{" "}
                      <select
                        name="avatarId"
                        value={this.state.newCompany.avatarId}
                        onChange={this.handleInputChange}
                      >
                        <option value=""></option>
                        {this.state.organizationImages.map((image) => {
                          return (
                            <option key={image.Key} value={image.Key}>
                              {image.Key}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="control">
                      <label className="label">Underafdelinger:</label>
                      <CreatableSelect
                        isMulti
                        value={this.state.newCompany.subDivisions.map(
                          (division) => ({
                            value: division,
                            label: division,
                          })
                        )}
                        onChange={this.handleSubDivisionsChange}
                        placeholder="Vælg eller indsæt underafdelinger"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>

                    <div className="control">
                      <button
                        type="submit"
                        className="button is-primary is-medium"
                      >
                        Tilføj
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="column">
                {this.state.companies.map((company) => (
                  <Company
                    handleUpdateCompany={this.handleUpdateCompany}
                    handleDeleteCompany={this.handleDeleteCompany}
                    organizationImages={this.state.organizationImages}
                    company={company}
                    campaigns={this.state.campaigns}
                    key={company.id}
                    isAdmin={true}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
